import { useCallback } from 'react';
import type { NilableArray } from '~/utilities/type-guards';
import type { OnboardingActivityAction, OnboardingActivityEnum } from '~/graphql';
import { useOnboardingActivitiesLazyQuery } from './__gql/onboardingActivitiesByFeatureId.gql.gen';
import type { SupportedFeatureIds } from '../types';
import type { SupportedNudgeFeatureIds } from '../nudges/types';
import { getUniqueFeatureId } from '../utils/getUniqueFeatureId';

export const useOnboardingActivitiesByFeatureIdService = (): ((
  featureId: SupportedFeatureIds | SupportedNudgeFeatureIds,
  activityType?: OnboardingActivityEnum,
  forCurrentContact?: boolean,
) => Promise<
  NilableArray<{
    id: string;
    action: OnboardingActivityAction;
  }>
>) => {
  const [load] = useOnboardingActivitiesLazyQuery();

  return useCallback(
    async (
      featureId: SupportedFeatureIds | SupportedNudgeFeatureIds,
      activityType?: OnboardingActivityEnum,
      forCurrentContact?: boolean,
    ) => {
      const { data } = await load({
        variables: {
          activityType,
          featureId: getUniqueFeatureId(featureId),
          forCurrentContact,
        },
        fetchPolicy: 'no-cache',
      });

      return data?.currentUser?.onboardingActivities?.nodes;
    },
    [load],
  );
};
